export function formatUptime(seconds: number): {
  primary: string;
  detailed: string;
} {
  const years = Math.floor(seconds / 31536000); // 365 days
  const days = Math.floor((seconds % 31536000) / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Primary display
  let primary = '';
  if (years > 0) {
    primary = `${years}y ${days}d`;
  } else {
    primary = `${days}d`;
  }

  // Detailed breakdown
  const parts = [];
  if (years > 0) parts.push(`${years}y`);
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);

  const detailed = parts.join(' ') || '< 1m';

  return { primary, detailed };
}